const partnerPages = [
    {
        path: '/partner/:id',
        name: 'partner-details',
        component: () => import('@/views/members/PartnerDetails.vue'),
        meta: {
            layout: 'content',
            resource: 'VIEWADMINS',
        },
    },
    {
        path: '/referrals',
        name: 'referrals',
        component: () => import('@/views/members/Referrals.vue'),
        meta: {
            layout: 'content',
            resource: 'VIEWADMINS',
        },
    },
    {
        path: '/withdraws',
        name: 'withdraws',
        component: () => import('@/views/members/Withdraws.vue'),
        meta: {
            layout: 'content',
            resource: 'VIEWADMINS',
        },
    },
     {
        path: '/withdrawal/:id',
        name: 'withdrawal-details',
        component: () => import('@/views/members/WithdrawalDetails.vue'),
        meta: {
            layout: 'content',
            resource: 'VIEWADMINS',
        },
    },
]

export default partnerPages
